import { render, staticRenderFns } from "./ExecPlaceholder.vue?vue&type=template&id=56447bf4"
import script from "./ExecPlaceholder.vue?vue&type=script&lang=js"
export * from "./ExecPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports